/** DOM event fired when socket receives storefront_updated (tenant policy change). */
export const STOREFRONT_UPDATED_EVENT = 'catalogofworks:storefront-updated';

export function dispatchStorefrontUpdated(): void {
  window.dispatchEvent(new CustomEvent(STOREFRONT_UPDATED_EVENT));
}
